<app-com-center domain="Scheduling" [typeOptions]="typeOptions"></app-com-center>

